import { EProductTypeStr, TAdditionalProduct } from '~/src/api/common-types/additional-products.types';
import { IOfferContent } from '~/src/api/common-types/offerContent.types';
import { TTariffPackage } from '~/src/api/common-types/sale-package';
import { EShopCategory } from '~/src/api/content/shop/getShopItems';
import { IAdvantages } from '~/src/entities/formattedTariff';
import { getListDescription } from '~/src/features/full-buy/store/helpers/getListDescription';
import { TProduct, transformShopItem } from '~/src/features/full-buy/store/transformShopItem';

/**
 * Возвращает используемые свойства из description
 * @todo describe returned type
 */
export const getPropsFromDescription = (description: TTariffPackage['description'], tariff_name_display?: string) => {
    const {
        alias,
        title,
        tariff_name,
        color,
        color_text,
        image_background,
        tariffLines,
        tariffTags,
    } = description;

    return {
        alias,
        title: title || tariff_name_display || tariff_name,
        sort_on_bundles: 'sort_on_bundles' in description  ? description.sort_on_bundles : null,
        bgColor: color,
        colorText: color_text,
        image_background,
        image_background_webp: 'image_background_webp' in description ? description.image_background_webp : null,
        tariffLineAlias: tariffLines?.map(item => item.alias) || [],
        tariffTags: tariffTags.filter(el => typeof el === 'string'),
    };
};

export interface IAdditionalProduct extends TProduct {
    required: 0 | 1,

    basePrice: number,
    firstMonthPrice: number | null,
}

/**
 * Конвертит additionalProducts -> product
 */
export const transformAdditionalProducts = (additionalProducts: TAdditionalProduct[]): IAdditionalProduct[] => {
    return additionalProducts.map(item => {
        const product = transformShopItem(item.shopItem);
        // Подбираем цену по периоду, если не найдена берем price
        const price = { duration: item.leasing_duration, cost: item.price || 0 };
        const priceByDuration = product.prices.find(el => el.duration === item.leasing_duration) || price;

        return ({
            id: item.product_id,
            category: item.product_type === EProductTypeStr.TV ? EShopCategory.Decoders : item.product_type,
            title: product.title,
            categoryTitle: product.categoryTitle,
            description: product.description,
            body: product.body,
            image: product.image,
            images: product.images,
            props: product.props,
            labels: product.labels,
            image_width: product.image_width,
            image_height: product.image_height,
            image_webp: product.image_webp,
            prices: product.prices,
            selectedPrice: priceByDuration,
            quantity: item.required ? 1 : 0, // TODO добавить тест на это изменение, критично для создания договора
            required: item.required,
            name: item.shopItem.name,

            basePrice: item?.base_price || 0,
            firstMonthPrice: 'first_month_price' in item && typeof item.first_month_price === 'number' ? item.first_month_price : null,
        });
    });
};

export interface ISubscription {
    id: number,
    title: string,

    image_width: number,
    image_height: number,

    image: string,
    image_webp?: string,

    imageForFullBuy?: string | null,
    imageForFullBuyWebp?: string | null,
    bodyForFullBuy?: string,
    fullDescriptionList: string[],
    extendBodyForFullBuy?: string | null,
    image_mobile: string,
    sort: number,
    images?: string[] | null, // TODO - проверить наличие этого свойства в подписках.
    width?: number, // TODO - проверить наличие этого свойства в подписках.
}
/**
 * Возвращет подписки (tariff.offerContents)
 * isSupportsWebp - если true для свойства image подставляется картинка из image_webp иначе из image
 */
export const transformSubscription = (subscriptions: IOfferContent[], isSupportsWebp: boolean): ISubscription[] => {
    return subscriptions.map((subscription) => ({
        id: subscription.id,
        title: subscription.title,
        bodyForFullBuy: subscription.body_for_full_buy,
        fullDescriptionList: getListDescription(subscription.extend_body_for_full_buy ? subscription.extend_body_for_full_buy : ''),
        extendBodyForFullBuy: subscription.extend_body_for_full_buy,

        // Содержит картинку в формате webp если браузер поддерживает
        image: isSupportsWebp ? (subscription.image_webp || subscription.image) : subscription.image,
        image_mobile: isSupportsWebp ? (subscription.image_mobile_webp || subscription.image_mobile) : subscription.image_mobile,
        imageForFullBuy: isSupportsWebp ? (subscription.extend_image_for_full_buy_webp || subscription.extend_image_for_full_buy) : subscription.extend_image_for_full_buy,

        image_width: subscription.image_width,
        image_height: subscription.image_height,

        // TODO Свойства можно будет убрать, там где была проверка на webp
        image_webp: subscription.image_webp,
        imageForFullBuyWebp: subscription.extend_image_for_full_buy_webp,
        sort: subscription.sort,
    }));
};

/**
 * Возвращает скорость скачивания
 */
export const getSpeedDescription = (items: IAdvantages[]): string  => {
    if (items?.length) {
        const parseString = 'скорость скачивания';
        const matches = items?.filter((item) =>  item?.description?.toLowerCase().includes(parseString) === true);
        if (matches?.length && matches[0]?.description) {
            return matches[0].description;
        }
    }

    return '';
};
